<ng-container *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-date ttLabel="invoice_date" [(ttModel)]="get.invoice_date"></tt-date>
        <tt-input ttLabel="invoice_valuta_id" [(ttModel)]="get.invoice_valuta_id" ttReadonly>
            <tt-form-field-button buttons *ngIf="!navigator" ttIcon="fas fa-cog" ttGoto="webpagesetting" [ttGotoParms]="{ argtype: 'webpage_name', argvalue: 'orderheadmi' }"></tt-form-field-button>
        </tt-input>

        <tt-button-save *ngIf="get.setting_manual_invoicing === '0'" ttText="orderheadmi_create_invoice" (ttClick)="createInvoice()" [ttLoading]="creatingInvoice"></tt-button-save>
        <tt-button-save *ngIf="get.setting_manual_invoicing === '1'" ttText="orderheadmi_manual_create_invoice" (ttClick)="createManualInvoice()" [ttLoading]="creatingManualInvoice"></tt-button-save>
    </tt-card>

    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>

    <tt-card *ngIf="!!navigator">
        <tt-button-settings ttWebpageName="orderheadmi"></tt-button-settings>
    </tt-card>
</ng-container>
